$('.content-toggle').on('click', function(){
	$(this).toggleClass('active');
	$(this).parents('section').find('.content-container').slideToggle().toggleClass('open');

	if ( contentOpenCheck() ) {
		$('#collapse-toggle').text('Collapse All').addClass('active');
	} else {
		$('#collapse-toggle').text('Expand All').removeClass('active');
	}
});

$('#collapse-toggle').on('click', function() {
	if ( contentOpenCheck() ) {
		$('#collapse-toggle').removeClass('active');
		$('#collapse-toggle').text('Expand All');
		$('.content-container').each(function() {
			$(this).slideUp().removeClass('open');
		});
		$('.content-toggle').each(function(){
			$(this).removeClass('active');
		});
	} else {
		$('html, body').animate({
			scrollTop: $('#air-quality-climate-change').offset().top - 100
		}, 250);

		$('#collapse-toggle').addClass('active');
		$('#collapse-toggle').text('Collapse All');
		$('.content-container').each(function() {
			$(this).slideDown().addClass('open');
		});
		$('.content-toggle').each(function(){
			$(this).addClass('active');
		});
	}
});

function contentOpenCheck() {
	if ($(".content-container.open").length > 0) {
		return true;
	} else {
		return false;
	}
}
